// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__xzoUDEVe","default":"secondaryButton_default__vvvHgtU6","active":"secondaryButton_active__hbQ-9HAc"};